import { Controller } from '@hotwired/stimulus';

export default class AdIdController extends Controller {
  static targets = ['input'];

  disconnect() {
    this.inputTarget.value = '';
  }

  navigate() {
    const value = this.inputTarget.value.trim();
    if (!value) {
      return;
    }
    window.open(`/${encodeURIComponent(value)}`, '_blank');
  }
}
